module.exports = __webpack_public_path__ + "img/arrow-up.8c855c1e.svg";